export default {
  categories: {
  shoes: 'Schuhe',
  hoodies: 'Hoodies/Sweatshirts',
  tshirts: 'T-Shirts',
  jackets: 'Jacken',
  pants: 'Hosen/Shorts',
  headwear: 'Kopfbedeckungen',
  sets: 'Sets',
  underwear: 'Unterwäsche/Unterhosen',
  jersey: 'Trikots',
  accessories: 'Accessoires',
  bags: 'Taschen',
  belts: 'Gürtel',
  perfumes: 'Parfums',
  other: 'Sonstiges',
  },
};